import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type AlertType = 'error' | 'success' | 'warning' | 'info';

interface AlertTypeClasses {
  box: string;
  text: string;
}

const TYPE_CLASSES: Record<AlertType, AlertTypeClasses> = {
  error: {
    box: 'border-red-500 bg-red-500/10 dark:bg-red-900/10',
    text: 'text-red-500',
  },
  success: {
    box: 'border-emerald-500 bg-emerald-500/10 dark:bg-emerald-900/10',
    text: 'text-emerald-600',
  },
  warning: {
    box: 'border-amber-500 bg-amber-500/10 dark:bg-amber-900/10',
    text: 'text-amber-600',
  },
  info: {
    box: 'border-sky-500 bg-sky-500/10 dark:bg-sky-900/10',
    text: 'text-sky-600',
  },
};

@Component({
  selector: 'app-alert',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  template: `
    @if (message()) {
      <div
        role="alert"
        class="flex items-start gap-3 rounded-md border p-4 {{ typeClasses().box }}"
      >
        <ng-content select="[appAlertIcon]"></ng-content>
        <div class="grow">
          <h3 class="text-sm font-medium {{ typeClasses().text }}">
            {{ message() }}
          </h3>
          <ng-content></ng-content>
        </div>
      </div>
    }
  `,
})
export class AlertComponent {
  readonly message = input<string | null | undefined>(null);
  readonly type = input<AlertType>('error');

  protected typeClasses(): AlertTypeClasses {
    return TYPE_CLASSES[this.type()] ?? TYPE_CLASSES.error;
  }
}